// src/components/BulkWhatsAppModal.jsx — Bulk WhatsApp messaging template composer
import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { MessageSquare, X, ExternalLink } from 'lucide-react';
import toast from 'react-hot-toast';

export default function BulkWhatsAppModal({ show, onHide, selectedLeads }) {
  const [message, setMessage] = useState(
    'Hello {{name}}, thank you for contacting Platinum Auto Japan! How can we assist you today?'
  );

  if (!selectedLeads || selectedLeads.length === 0) return null;

  const handleLaunchAll = () => {
    selectedLeads.forEach((lead, idx) => {
      if (!lead.number) return;
      const cleanPhone = String(lead.number).replace(/[^0-9]/g, '');
      const personalizedMsg = message.replace(/{{name}}/g, lead.name || 'Customer');
      const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(personalizedMsg)}`;
      
      // Stagger tab opens slightly to avoid browser pop-up block
      setTimeout(() => {
        window.open(waUrl, '_blank', 'noopener,noreferrer');
      }, idx * 400);
    });
    toast.success(`Opening WhatsApp chats for ${selectedLeads.length} leads!`);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="dark-theme-modal">
      <Modal.Header style={{ borderBottom: '1px solid #334155', background: '#0f172a', color: '#f8fafc' }}>
        <Modal.Title style={{ fontSize: '16px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <MessageSquare size={18} style={{ color: '#22c55e' }} /> Bulk WhatsApp Message
        </Modal.Title>
        <button type="button" className="btn-close-custom" onClick={onHide} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer' }}>
          <X size={18} />
        </button>
      </Modal.Header>
      <Modal.Body style={{ background: '#0f172a', color: '#e2e8f0', padding: '20px' }}>
        <p style={{ fontSize: '13px', color: '#94a3b8', marginBottom: '16px' }}>
          You have selected <strong>{selectedLeads.length}</strong> leads. Compose your message template below. Use <code>{'{{name}}'}</code> for lead name substitution.
        </p>

        <Form.Group style={{ marginBottom: '16px' }}>
          <Form.Label style={{ fontSize: '12px', fontWeight: 600, color: '#cbd5e1' }}>Message Template</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{
              background: '#1e293b',
              border: '1px solid #334155',
              color: '#f8fafc',
              borderRadius: '8px',
              fontSize: '14px',
            }}
          />
        </Form.Group>

        <div style={{ background: '#1e293b', padding: '12px', borderRadius: '8px', border: '1px solid #334155' }}>
          <span style={{ fontSize: '11px', color: '#94a3b8', display: 'block', marginBottom: '4px' }}>RECIPIENTS ({selectedLeads.length}):</span>
          <div style={{ maxHeight: '100px', overflowY: 'auto', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {selectedLeads.map((l) => (
              <span key={l.id || l._id} style={{ fontSize: '12px', background: '#0f172a', padding: '2px 8px', borderRadius: '4px', color: '#38bdf8', fontFamily: 'monospace' }}>
                {l.name || 'Lead'} ({l.number})
              </span>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '1px solid #334155', background: '#0f172a', display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="secondary" onClick={onHide} style={{ background: '#334155', border: 'none', fontSize: '13px' }}>
          Cancel
        </Button>
        <Button onClick={handleLaunchAll} style={{ background: '#22c55e', border: 'none', fontSize: '13px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '6px' }}>
          <ExternalLink size={14} /> Launch WhatsApp Chats ({selectedLeads.length})
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
